var map = {
	"./background-destination-desktop.jpg": 244,
	"./background-destination-mobile.jpg": 719,
	"./background-destination-tablet.jpg": 779,
	"./image-europa.png": 543,
	"./image-europa.webp": 564,
	"./image-mars.png": 808,
	"./image-mars.webp": 804,
	"./image-moon.png": 641,
	"./image-moon.webp": 8,
	"./image-titan.png": 946,
	"./image-titan.webp": 732
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 961;